/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_TitleInputs */

const en_automatic_save_title = /** @type {(inputs: Automatic_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restore Event Groups`)
};

const fr_automatic_save_title = /** @type {(inputs: Automatic_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restaurer les groupes d’événements`)
};

const de_automatic_save_title = /** @type {(inputs: Automatic_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisgruppen wiederherstellen`)
};

const it_automatic_save_title = /** @type {(inputs: Automatic_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ripristina gruppi di eventi`)
};

const ru_automatic_save_title = /** @type {(inputs: Automatic_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Восстановить группы событий`)
};

const es_automatic_save_title = /** @type {(inputs: Automatic_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restaurar grupos de eventos`)
};

const zh_cn2_automatic_save_title = /** @type {(inputs: Automatic_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`恢复事件组`)
};

const ja_automatic_save_title = /** @type {(inputs: Automatic_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループを復元する`)
};

const hi_automatic_save_title = /** @type {(inputs: Automatic_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट समूहों को पुनर्स्थापित करें`)
};

const pt_pt2_automatic_save_title = /** @type {(inputs: Automatic_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restaurar grupos de eventos`)
};

/**
* | output |
* | --- |
* | "Restore Event Groups" |
*
* @param {Automatic_Save_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_title = /** @type {((inputs?: Automatic_Save_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_save_title(inputs)
	if (locale === "de") return de_automatic_save_title(inputs)
	if (locale === "it") return it_automatic_save_title(inputs)
	if (locale === "ru") return ru_automatic_save_title(inputs)
	if (locale === "es") return es_automatic_save_title(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_save_title(inputs)
	if (locale === "ja") return ja_automatic_save_title(inputs)
	if (locale === "hi") return hi_automatic_save_title(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_save_title(inputs)
	return en_automatic_save_title(inputs)
});